import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '../../../store/state';
import { UpdateField } from '@webapp/store/release/action-creators';

import Checkbox from '@components/form/checkbox';
import { Translate } from 'react-localize-redux';

interface AppleMusicCtrlProps {
  className?: string;
  hasAppleMusic?: boolean;
  isSubscribed: boolean;
  updateHasAppleMusic: (value: boolean) => UpdateField<'hasAppleMusic'>;
}

const mapStateToProps = (state: AppState) => {
  return {
    hasAppleMusic: state?.release.release?.hasAppleMusic,
    isSubscribed: !!state.subscription.current?.isActive,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateHasAppleMusic: (value: boolean) =>
    dispatch(new UpdateField<'hasAppleMusic'>('hasAppleMusic', value)),
});

export const AppleMusicCtrl: React.FC<AppleMusicCtrlProps> = ({
  updateHasAppleMusic,
  hasAppleMusic,
  isSubscribed,
  ...props
}) => {
  React.useEffect(() => {
    if (isSubscribed && hasAppleMusic === undefined) {
      updateHasAppleMusic(true);
    }
  }, [isSubscribed, updateHasAppleMusic, hasAppleMusic]);

  return (
    <div className={props.className}>
      <Checkbox
        active={!!hasAppleMusic}
        onClick={() => updateHasAppleMusic(!hasAppleMusic)}
        title={<Translate id="RELEASE.APPLE_DISTRIBUTION.TITLE" />}
        text={<Translate id="RELEASE.APPLE_DISTRIBUTION.COPY" />}
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AppleMusicCtrl);
